module.exports = __webpack_public_path__ + "img/3.f6692f82.png";